import React from 'react';

import TopOptions from './components/TopOptions';
import BottomOptions from './components/BottomOptions';

const HeaderOptions = ({
  modelName,
  topLeftOptions,
  topRightOptions,
  bottomLeftOptions,
  bottomRightOptions,
}) => (
  <React.Fragment>
    <TopOptions
      modelName={modelName}
      left={topLeftOptions}
      right={topRightOptions}
    />
    <BottomOptions left={bottomLeftOptions} right={bottomRightOptions} />
  </React.Fragment>
);

HeaderOptions.propTypes = {
  ...TopOptions.propTypes,
  ...BottomOptions.propTypes,
};

export default HeaderOptions;
